<template>
  <v-dialog scrollable persistent
    v-model="config.status.active"
    max-width="600">
    <v-card>
      <v-card-title class="primary blue-grey--text text--darken-4 headline">{{ printTitle }}</v-card-title>
      <v-card-text>
        <v-form lazy-validation
          ref="form"
          v-model="form.valid">
          <v-row dense v-if="!$props.type">
            <v-col cols="12" align="right">
              <v-btn-toggle mandatory dense class="grey lighten-3" v-model="form.type" @change="changeType">
                <v-btn :text="form.type !== 'client'" :depressed="form.type === 'client'" color="secondary white--text" :value="'client'">顧客</v-btn>
                <v-btn :text="form.type !== 'company'" :depressed="form.type === 'company'" color="secondary white--text" :value="'company'">企業</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row dense v-if="form.type === 'client'">
            <v-col  cols="12" sm="6" class="px-2">
              <v-text-field ref="firstInput"
                label="姓"
                v-model="form.name[0]"
                counter="10"
                :rules="rules.name"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="名"
                v-model="form.name[1]"
                counter="10"
                :rules="rules.name"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="せい"
                v-model="form.kana[0]"
                counter="10"
                :rules="rules.kana"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="めい"
                v-model="form.kana[1]"
                counter="10"
                :rules="rules.kana"
              />
            </v-col>
            <v-col cols="12" class="px-2">
              <v-select
                label="担当"
                v-model="form.author"
                :items="getConsultantItems"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
          <v-row dense v-else-if="form.type === 'company'">
            <v-col cols="12">
              <v-text-field ref="firstInput"
                label="会社名"
                v-model="form.name"
                counter="20"
                :rules="rules.name"
              />
            </v-col>
          </v-row>
          <v-progress-linear v-if="isSearching" indeterminate color="secondary"></v-progress-linear>
          <v-row dense v-if="getClientItems.length">
            <v-col cols="12">
              <v-checkbox
                v-model="form.confirm"
                color="secondary"
                :label="`類似した顧客：${getClientItems.length}人を確認`"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
          <v-list dense v-if="getClientItems.length">
            <template v-for="item in getClientItems">
              <v-list-item :key="item.id">
                <v-list-item-content v-if="form.type === 'client'">
                  <v-list-item-subtitle class="caption">{{ item.kana ? item.kana.replace(',', ' ') : '' }}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.name ? item.name.replace(',', ' ') : '' }}</v-list-item-title>
                  <v-list-item-subtitle class="caption"><span class="font-weight-bold">担当：</span>{{ meta.authors[item.aid] ? meta.authors[item.aid].name[0] : item.author }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else-if="form.type === 'company'">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`${item.id}_div`"></v-divider>
            </template>
          </v-list>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          @click.stop="insert"
          :loading="isLoading"
          :disabled="!isValid || isLoading">登録する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'insert-modal',
  components: {
  },
  props: [ 'type' ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          initializing: false
        }
      },
      meta: {
        authors: []
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ],
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ]
      },
      store: {
        authors: [],
        clients: []
      },
      form: {
        valid: true,
        kana: ['', ''],
        name: ['', ''],
        author: ''
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    init: function (req) {
      const type = this.$props.type || (req && req.type) || 'client'
      const { kana, name, author } = type === 'client' ? {
        kana: req && req.kana || ['', ''],
        name: req && req.name || ['', ''],
        author: req && req.author || ''
      } : {
        kana: req && req.kana,
        name: req && req.name,
        author: ''
      }
      this.$set(this, 'form', type === 'client' ? {
        valid: true,
        confirm: false,
        type,
        kana: [ kana[0] || '', kana[1] || ''],
        name: [ name[0] || '', name[1] || ''],
        author: author || ''
      } : {
        valid: true,
        confirm: false,
        type,
        name: name || '',
      })
      this.$set(this.store, 'clients', [])
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.firstInput) {
            this.$refs.firstInput.focus()
          }
        })
      })
    },
    emitted: function (req) {
      const { dest, action, data } = req || {}
      if (dest) {
        if (action && this.$refs[dest] && typeof this.$refs[dest][action] === 'function') {
          this.$refs[req.dest][req.action](req.data)
        }
      } else {
        if (action && typeof this[action] === 'function') {
          this[action](data)
        }
      }
    },
    insert: function () {
      this.submit({ type: 'insert' })
    },
    preSubmit: function (req) {
      const { type } = req
      const { kana, name, author } = this.form
      const clientType = this.form.type || 'client'
      const urls = {
        client: `${this.$url.api}client/get/items`,
        insert: `${this.$url.api}clients/insert/item/withbox`
      }
      const fds = {
        client: clientType === 'client' ? {
          type: clientType,
          name: kana.join('') || name.join('') || ''
        } : {
          type: clientType,
          name
        },
        insert: clientType === 'client' ? {
          type: clientType,
          name: name.join(','),
          kana: kana.join(','),
          author
        } : {
          type: clientType,
          name
        }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'insert' && this.$refs.form.validate()) {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'client') {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.form, 'confirm', false)
        this.$set(this.store, 'clients', data)
      } else if (type === 'insert') {
        this.$set(this.config.status, 'loading', false)
        this.done(data)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    changeType: function () {
      const { type } = this.form
      this.init({ type })
    },
    searchClient: _.debounce(function (val) {
      const { type, name, kana } = this.form
      if (type === 'client') {
        const search = kana.join('') || name.join('') || ''
        if (search) {
          this.submit({ type: 'client' })
        }
      } else if (type === 'company') {
        const search = name
        if (search) {
          this.submit({ type: 'client' })
        }
      }
    }, 300),
    done: function (req) {
      this.$emit('done', req)
      this.close()
    },
    open: function () {
      this.$set(this.config.status, 'active', true)
      this.init()
      this.$emit('open')
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  watch: {
    'form.name': function (val) {
      if (this.form.type === 'client') {
        if (val.join('') && !this.config.status.searching) {
          this.searchClient()
        }
      } else if (this.form.type === 'company') {
        if (val && !this.config.status.searching) {
          this.searchClient()
        }
      }
    },
    'form.kana': function (val) {
      if (this.form.type === 'client') {
        if (val.join('') && !this.config.status.searching) {
          this.searchClient()
        }
      } else if (this.form.type === 'company') {
        if (val && !this.config.status.searching) {
          this.searchClient()
        }
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printTitle () {
      const { type } = this.$props
      return type === 'client' ? '新規顧客の追加' : (type === 'company' ? '新規企業の追加' : '新規顧客・企業の追加')
    },
    getStatus () {
      return this.config.status
    },
    currentPage () {
      return this.config.page
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients : []
    },
    getConsultantItems () {
      const authors = this.$store.getters['config/get']('authors')
      const keys = Object.keys(authors)
      return keys.length ? keys.filter(key => {
        return authors[key].roles.includes('consultant')
      }).map(key => {
        return {
          text: authors[key].name[0] || key,
          value: key
        }
      }) : []
    }
  }
}
</script>
